import Vue from 'vue'

export default {
	list({}, filter) {
		return Vue.api.post('access/list', {
			per_page: filter.per_page || 10,
			current_page: filter.current_page || 1
		})
	},
	get({}, id) {
		return Vue.api.get('access/' + id)
	},
	update({}, model) {

	},
	delete({}, id) {

	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/access/actions.js